var $4ca2ddcee0767497$exports = {};
$4ca2ddcee0767497$exports = {
    "loading": `Laster inn ...`,
    "loadingMore": `Laster inn flere ...`
};


export {$4ca2ddcee0767497$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
